export const APP_ENV = process.env.REACT_APP_APP_ENV || "DEV";

function isLocalDevHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

// CRA bakes .env at start — if it still points to prod, force local services on localhost.
export const API_BASE = isLocalDevHost()
  ? "http://localhost:3000"
  : (process.env.REACT_APP_API_BASE || "http://localhost:3000");

export const UPLOAD_API_BASE = isLocalDevHost()
  ? "http://localhost:5000"
  : (process.env.REACT_APP_UPLOAD_API_BASE || "http://localhost:5000");

const CARTO_API_KEY = process.env.REACT_APP_CARTO_API_KEY || "";
export const CARTO_LIGHT_TILE_URL = CARTO_API_KEY
  ? `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${CARTO_API_KEY}`
  : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
export const CARTO_TILE_ATTRIBUTION = "&copy; OpenStreetMap &copy; CARTO";
